<div class="card shadow p-3 h-100">
  <app-automation-type-select [type]="type" (typeChange)="onTypeChange($event)"></app-automation-type-select>
  <div class="mb-5 flex-fill">
    <ng-content></ng-content>
  </div>
  <div>
    <img [src]="image" alt="" class="w-100" />
  </div>
</div>
